import styled, { keyframes } from "styled-components";
import BreakpointUp from "../Media/BreakpointUp"

export const Section = styled.section`
  background-image: ${(props) => props.bgImg};
  background-color: ${(props) => props.bgColor};
  background-size: ${(props) => props.bgSize};
  height: ${(props) => props.ht};
  text-align: ${(props) => props.textAlign};
  position: relative;
  z-index: ${(props) => props.zIndex};
  padding-top: ${(props) => props.pt};
  padding-bottom: ${(props) => props.pb};
  overflow: ${(props) => props.overflow};
  &:before, &:after {
    content: "";
    position: absolute;
  }
  &:before {
    display: ${(props) => (props.bgBefore ? "block" : "none")};
    top: ${(props) => props.topBefore};
    right: ${(props) => props.rightBefore};
    bottom: ${(props) => props.bottomBefore};
    left: ${(props) => props.leftBefore};
    background: ${(props) => props.bgBefore};
    background-size: ${(props) => props.bgBeforeSize};
    background-repeat: ${(props) => props.bgBeforeRepeat};
    width: ${(props) => props.bgBeforeWidth};
    height: ${(props) => props.bgBeforeHeight};
    opacity: ${(props) => props.opacityBefore};
  }
  &:after {
    display: ${(props) => (props.bgAfter ? "block" : "none")};
    top: ${(props) => props.topAfter};
    right: ${(props) => props.rightAfter};
    bottom: ${(props) => props.bottomAfter};
    left: ${(props) => props.leftAfter};
    background: ${(props) => props.bgAfter};
    background-size: ${(props) => props.bgAfterSize};
    background-repeat: ${(props) => props.bgAfterRepeat};
    width: ${(props) => props.bgAfterWidth};
    height: ${(props) => props.bgAfterHeight};
    opacity: ${(props) => props.opacityAfter};
  }
  ${BreakpointUp.lg`
		padding-top: ${(props) => props.lpt};
		padding-bottom: ${(props) => props.lpb};
		margin-top: ${(props) => props.lmt};
		margin-bottom: ${(props) => props.lmb};
	`}
  ${BreakpointUp.xl`
		padding-top: ${(props) => props.xpt};
		padding-bottom: ${(props) => props.xpb};
	`}
	${BreakpointUp.xxl`
		padding-top: ${(props) => props.ept};
		padding-bottom: ${(props) => props.epb};
	`}
`;

Section.defaultProps = {
  top: "0",
  bgImg: "inherit",
  bgColor: "#fff",
  bgSize: "inherit",
  textAlign: "left",
  topAfter: "0",
  topBefore: "0",
  pt:"30px",
  pb:"30px",

  xpt:"40px",
  xpb:"40px",

  ept:"60px",
  epb:"60px",
};

export const Container = styled.div`
	position: relative;  
    width: 100%;
    margin-right: auto;
	margin-left: auto;
    padding-right: ${props=>props.pr};
    padding-left: ${props=>props.pl};
	max-width: ${props=>props.maxWidth};
	overflow: ${props=>props.overflow};
`
Container.defaultProps = {
	maxWidth: "1440px",
	overflow: "inherit",
	pr: "15px",
	pl: "15px",
}

export const ContainerFluid = styled.div`
  position: relative;
  z-index: ${(props) => props.zIndex};
  max-width: ${(props) => props.maxWidth};
  width: 100%;
  margin: 0 auto;
  padding: 0 15px;
`;

ContainerFluid.defaultProps = {
  zIndex: "inherit",
  maxWidth: "100%",
};


export const SectionPageTitle = styled.h1`
	position: relative;
	width:100%;
	max-width: ${props=>props.maxWidth};
	color: ${props=>props.color};
	text-align: ${props=>props.textAlign};
	margin-top: ${props=>props.mt};	
	margin-bottom: ${props=>props.mb};	
	margin-left:${props=>props.ml};
	margin-right:${props=>props.mr};
	
`

SectionPageTitle.defaultProps = {
	textAlign: "center",
	color: "#000",
	maxWidth: "100%",
	mt: "auto",
	mr: "auto",
	ml: "auto",
	mb: "15px",
}

export const SectionTitle = styled.h2`
	position: relative;
	width:100%;
	max-width: ${props=>props.maxWidth};
	color: ${props=>props.color};
	text-align: ${props=>props.textAlign};
	margin-top: ${props=>props.mt};	
	margin-right:${props=>props.mr};
	margin-bottom: ${props=>props.mb};	
	margin-left:${props=>props.ml};
	padding-left:${props=>props.pl};
	padding-right:${props=>props.pr};
`

SectionTitle.defaultProps = {
	textAlign: "center",
	color: "#000",
	maxWidth: "100%",
	mt: "auto",
	mr: "auto",
	ml: "auto",
	mb: "15px",
	pl: "0px",
	pr: "0px"
}

export const SubTitle = styled.h3`
	margin-top: ${props=>props.mt};
	margin-left:${props=>props.ml};
	margin-right:${props=>props.mr};
	margin-bottom: ${props=>props.mb};	
	text-align: ${props=>props.textAlign};
	max-width:${props=>props.maxWidth};
	color: ${props=>props.color};
	width: ${props=>props.color};
	font-size: ${props=>props.fontSize};
	@media(max-width: 991px) {
		margin-top: ${props=>props.mpt};	
		margin-bottom: ${props=>props.mpb};	
	}
`
SubTitle.defaultProps = {
	textAlign: "center",
	maxWidth: "100%",
	color: "#000",
	ml: "auto",
	mr: "auto",
	width: "100%",
}


export const SectionLead = styled.p`
	margin-left:${props=>props.ml};
	margin-right:${props=>props.mr};
	margin-bottom: ${props=>props.mb};	
	text-align: ${props=>props.textAlign};
	max-width:${props=>props.maxWidth};
	color: ${props=>props.color};
	width:100%;
	font-weight: 500;

	font-size: 16px;
	line-height: 28px;
	@media (min-width: 1200px) {
		font-size: 18px;
		line-height: 28px;
	}
	@media (min-width: 1600px) {
		font-size: 20px;
		line-height: 30px;
	}
	
`
SectionLead.defaultProps = {	
	textAlign: "center",
	maxWidth: "100%",
	color: "#666",
	ml: "auto",
	mr: "auto",
	mb: "10px",
}

export const SectionDescription = styled.div`
	margin-left: ${props=>props.ml};
	margin-right:${props=>props.mr};
	text-align: ${props=>props.textAlign};
	margin-bottom: ${props=>props.mb};
	max-width:${props=>props.maxWidth};
	color: ${props=>props.color};
	padding-left:${props=>props.pl};
	padding-right:${props=>props.pr};
	font-family: ${props=>props.fontFamily};
	width:100%;
	position: relative;

	& p {
		margin-bottom:0;	
		+ p{
			margin-top:20px;
		}
		a {
			display:inline-block;
			color:#D7272C;
			&:hover, &:focus {
				text-decoration: underline;
			}
		}
	}
	
`
SectionDescription.defaultProps = {
	textAlign: "center",
	mb: "30px",
	maxWidth: "100%",
	color: "#574C4C",
	ml: "auto",
	mr:"auto",
	pl: "0px",
	pr: "0px",
}

export const BreadCrumb = styled.div`		
	position: ${props=>props.position};	
	z-index:2;
	font-weight: normal;	
	margin:0 -10px ${props=>props.mb} -10px;
	font-size: 14px;
    line-height: 20px;
	a {
		color: #D7272C;
		font-weight:500;
		&:hover{
			color:#000;
		}
	}
	span{
		&:last-child::after{
			display:none;
		}
	}
	a, span{
		position:relative;
		padding:0 10px;
		&:after{
			content: '/';
			position:absolute;
			right:-4px;		
			top:50%;
			transform: translateY(-50%);
			color:#574C4C;
			font-weight:400;

		}
	}
	&.white{
		a {
			&:hover{
				color:#fff;
			}
		}
		span{
			color:#fff;
		}
		a, span{
			&:after{
				color:#fff;
			}
		}
	}
`

BreadCrumb.defaultProps = {
	position: "relative",
	mb: "5px",

}

export const IsSticky = styled.div`
	top: 75px;
	${BreakpointUp.xl`
		position: sticky;
		top: 145px;
	`}
`

export const ListBadge = styled.div`	
	display:flex;
	flex-wrap:wrap;
	margin:-5px -10px;
`
export const ListItemBadge = styled.div`		
	padding:5px 10px;
`
export const Badge = styled.span`	
	background-color:${props=>props.bgColor};
    border-radius:${props=>props.radius};
	color:${props=>props.color};
	font-size: 12px;
    line-height: 20px;
    font-weight: 400;
    padding: 2px 7px;
`

Badge.defaultProps = {
	bgColor: "#EDEDED",
	color: "#707070",
	radius: "20px"
}

export const MarkdownContent = styled.div`
	display: ${props=>props.display};
	max-width:${props=>props.maxWidth};
	padding-left:${props=>props.pl};
	padding-right:${props => props.pr};
	margin:0 auto;
	margin-top:${props => props.mt};
	margin-bottom:${props=>props.mb};
	text-align:${props=>props.textAlign};
	width:100%;
	z-index: 1;
	position: relative;	

	h2{
		&:first-child{
			padding-top:0;
		}
		padding-top: 10px;
		@media (min-width: 1200px) {
			padding-top: 20px;
		}
		@media (min-width: 1600px) {
			padding-top: 40px;
		}		
	}

	h3{
		padding-top: 5px;
		@media (min-width: 1600px) {
			padding-top: 10px;
		}
	}
	& ul{
		margin-bottom: 30px;
		@media (min-width: 1600px) {
			margin-bottom: 40px;
		}
	}
	& hr{
		margin:30px 0;
		@media (min-width: 1200px) {
			margin:40px 0;
		}
		@media (min-width: 1600px) {
			margin:60px 0;
		}
		+ h2, + h3{
			padding-top:0;
		}
	}

	& p {
		color: ${props=>props.color};

		a {
			color: #D7272C;
			&:hover, &:focus{
				text-decoration: underline;
				color:#000;
			}
		}
	}

	& span {
		line-height:28px;
	}
	& strong {
		color:#000;
	}

	& a {
		display:inline-block;
		color: #D7272C;
		font-weight:600;
		&:hover, &:focus{
			text-decoration: underline;
			color:#000;
		}
	}
	
	& ul {
		padding:0;
		font-weight: 500;
        color:#000;
		font-size:16px;
		line-height:26px;
		margin-left: 20px;
		list-style: circle;
		@media (min-width: 1600px) {
			font-size:18px;
			line-height:32px;
		}
		& li {
			padding-left: 0px;
			vertical-align: text-top;
			margin: 0;
			color: ${props=>props.color};
			
			+ li{
				margin-top:5px;
				color: inherit;
			}

			&::marker {
				color: red;
			}
		}
	}
	& table {
		width: 100%;
		min-width: 100%;
		thead {
			background: #938888;

			th {
				border: 0px;
				color: #FFFFFF;
				font-size: 16px;
			}
			th:first-child {
				padding-left: 30px;
			}
		}
		tbody {
			tr {
				background: #F7F5F5;
				border-bottom: 3px solid #ffffff;

				td {
					font-size: 14px;
				}

				td:first-child {
					padding-left: 30px;
				}
			}
		}
		@media (max-width: 991px){
			min-width: 900px;
		}
	}
`

MarkdownContent.defaultProps = {
	textAlign: "left",
	maxWidth: "none",
	pl: "0",
	pr: "0",
	display: 'block',
	mt: "0",
	mb:"0"
}

export const MarkdownBody = styled.div`
	position: relative;
    box-shadow:0 25px 50px rgba(3,51,102,0.2);
	background-color:${props=>props.bgColor};
	max-width:${props=>props.maxWidth};
	padding: 40px 15px;    
    @media (min-width: 576px){
		padding:50px 30px;    
	}
    @media (min-width: 1200px){
        padding: 60px 30px;
    }
    @media (min-width: 1600px){
        padding: 90px 30px;
    }
`
MarkdownBody.defaultProps = {
	maxWidth: "none",
	bgColor:"#fff"
}

export const MarkDownRow = styled.div`    
    display: flex;
    flex-wrap: wrap;
    align-items:center;
    margin:0 -15px;
    @media (min-width: 992px){ 
        margin:0 -20px;
    }
`
export const MarkDownTwocol = styled.div`
    position: relative;
    width:100%;
    padding:0 15px;
	margin-bottom:30px;
    @media (min-width: 992px){ 
        padding:0 20px;
        flex: 0 0 50%;
        max-width: 50%;
		margin-bottom:0;
    }
	p{
		margin-bottom:0;
		+ p, + ul{
			margin-top:30px;
			@media (min-width: 1600px) {
				margin-top:40px;
			}
		}
	}
`
export const MarkDownLeft = styled.div`
    position: relative;
    width:100%;
    padding:0 15px;
	margin-bottom:30px;
    @media (min-width: 992px){ 
        padding:0 20px;
        flex-basis: 0;
        flex-grow: 1;
        max-width: 100%;
		margin-bottom:0;
    }
	p{
		margin-bottom:0;
		+ p, + ul{
			margin-top:30px;
			@media (min-width: 1600px) {
				margin-top:40px;
			}
		}
	}
`
export const MarkDownRight = styled.div`
    position: relative;
    width:100%;
    padding:0 15px;
    .gatsby-image-wrapper {
    	width: 100%;
    }
    @media (min-width: 992px){ 
        padding:0 20px;
        flex: 0 0 33.333333%;
        max-width: 33.333333%;
    }
    @media (min-width: 1600px){ 
        flex: 0 0 25%;
        max-width: 25%;
    }
`
export const BaseButton = styled.span`
	font-family: "Barlow", sans-serif;
	display: inline-flex;
    align-items: center;
	position:relative;
	text-align:center;
	border-radius: 6px;
	font-size:16px;
	line-height:24px;
	font-weight:600;
	border:1px solid transparent;
	text-transform:uppercase;	
	justify-content: center;
	box-sizing: border-box;
    overflow: hidden;
	transition: all 0.5s cubic-bezier(0.42, 0, 0.58, 1);
	padding:6px 12px;
	@media (min-width:992px) {
		padding:9px 15px;
	}

	&:before, &:after {
		content: "";
		position: absolute;
		display: block;
		box-sizing: border-box;
		top: 0;
		left: 0;
	}
	&:after {
		top: 0;
		left: 0;
		width: 0;
		height: 100%;	
		mix-blend-mode: screen;
		transition: all 0.5s cubic-bezier(0.42, 0, 0.58, 1);
	}
	&:hover {
		&:after {
			width: 100%;
			height: 100%;
		}
	}
	> .text{	
		+ .icon{
			margin-left:10px;
		}
	}
	> .icon{
		height: 24px;
		display: flex;
		align-items: center;
		justify-content:center;
		+ .text{
			margin-left:10px;
		}
		&:empty {
			display: none;
		}
	}
`

export const ExploreMore = styled.div`
	display:flex;
	align-items:center;
	justify-content:center;
	margin-top:${props=>props.mt};
	margin-bottom:${props=>props.mb};
	justify-content:${props=>props.justifyContent};
	flex-direction:${props=>props.flexDirection};	
	.btn{
		text-transform:${props=>props.textTransform};	
	}
`
ExploreMore.defaultProps = {
	mt: "0px",
	mb: "0px",
	justifyContent: "center",
	flexDirection: "row",
	textTransform: "uppercase",
}

export const SectionBgWrap = styled.div`
	position: absolute;
	z-index: 0;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	opacity: ${props => props.opacity};
	.gatsby-image-wrapper {
		width: 100%;
		height: 100%;
	}

	@media(max-width: 991px) {
		opacity: ${props => props.mOpacity};
	}
`

SectionBgWrap.defaultProps = {
	opacity: '1',
	mOpacity: '1',
}

export const StepWrapper = styled.div`
	position: absolute;
	width: 50px;
	color: ${props=>props.color};
	top: ${props=>props.top};
	left: ${props=>props.left};
	text-align: center;
	@media(max-width: 1600px) {
		left: 10px;
	}
	& span {
		display:block;
		font-size:11px;
		line-height:20px;
		font-weight:500;
	}
	& strong {
		display:block;
		font-family: "Barlow", sans-serif;
		font-weight: 700;
		color: ${props=>props.color};
		font-size: 20px;
		line-height: 24px;
		@media (min-width: 768px) {
			font-size: 22px;
			line-height: 24px;
		}
		@media (min-width: 1600px) {
			font-size: 24px;
			line-height: 24px;
		}
	}
	& svg {
		margin-top: 10px;
	}
	@media(max-width: 1200px) {
		display: none;
	}
`
StepWrapper.defaultProps = {
	top: "200px",
	color: "#FFFFFF33",
	left: "calc(50vw - 780px)"
}

export const HalfStep = styled.div`
  position: absolute;
  left: 23px;
`

export const SectionInnerWhite = styled.div`  
	background-color:${props=>props.bgColor};
	position: relative;
	box-shadow: 0 25px 50px rgb(3 51 102 / 20%);
	padding-top:40px;
	padding-bottom:40px;
	padding-left:${props=>props.pl};
	padding-right:${props=>props.pr};
	${BreakpointUp.xl`    
		padding-top:60px;
		padding-bottom:60px;
		padding-left:${props=>props.mpl};
		padding-right:${props=>props.mpr};
	`}
	${BreakpointUp.xxl`    
		padding-top:90px;
		padding-bottom:90px;
		padding-left:${props=>props.xpl};
		padding-right:${props=>props.xpr};
	`}
`
SectionInnerWhite.defaultProps = {
	bgColor:"#fff",

	pl:"4.166%",
	pr:"4.166%",
	
	mpl:"4.166%",
	mpr:"4.166%",

	xpl:"8.333%",
	xpr:"8.333%",
}

export const FlexWrap = styled.div`
	display: flex;
	flex-wrap: wrap;
	justify-content: ${props=>props.justifyContent};
	align-items: ${props=>props.alignItems};
	max-width: ${props=>props.maxWidth};
	margin-left: ${props=>props.ml};
	margin-right: ${props=>props.mr};
	margin-top: ${props=>props.mt};
	margin-bottom: ${props=>props.mb};
	@media(max-width: 991px) {
		flex-direction: ${props => props.flexDirection};
	}
`

FlexWrap.defaultProps = {
	alignItems: "flex-start",
	maxWidth: "100%",
	justifyContent: "space-between",
	ml: "auto",
	mr: "auto",
	mt: '0',
	mb: '0',
	flexDirection: 'inherit',
}

export const RightWrap = styled.div`
	width: ${props => props.width};
	margin-left: ${props => props.ml};
	margin-right: ${props => props.mr};
	margin-top: ${props => props.mt};
	margin-bottom: ${props => props.mb};
	@media(max-width: 991px) {
		width: 100%;
		margin-left: ${props => props.mml};
		margin-right: ${props => props.mmr};
		margin-top: ${props => props.mmt};
		margin-bottom: ${props => props.mmb};
	}
`

RightWrap.defaultProps = {
	width: "48%",
}

export const LeftWrap = styled.div`
	width: ${props => props.width};
	margin-left: ${props => props.ml};
	margin-right: ${props => props.mr};
	margin-top: ${props => props.mt};
	margin-bottom: ${props => props.mb};
	@media(max-width: 991px) {
		width: 100%;
		margin-left: ${props => props.mml};
		margin-right: ${props => props.mmr};
		margin-top: ${props => props.mmt};
		margin-bottom: ${props => props.mmb};
	}
`

LeftWrap.defaultProps = {
	width: "48%",
}

export const TextCenter = styled.div`
	text-align: center;
`

export const isBrowser = typeof window !== `undefined`;



export const Checkbox = styled.div`
	margin-bottom:0;
	label{
		[type="checkbox"]{
			width: 14px !important;
			height: 14px !important;
			padding: 0;
			margin:0;
			display: inline-block;
		}
	}
`
export const HelpText = styled.div`
	font-size:12px;
	line-height:20px;
	margin-bottom:15px;
`

export const FadeIn = keyframes`
  0% {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

const RingAnimation = keyframes`
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
`

export const DualRing = styled.div`
  display: block;
  width: 80px;
  height: 80px;
	margin: 100px auto;

  &:after {
    content: " ";
    display: block;
    width: 64px;
    height: 64px;
    margin: 8px;
    border-radius: 50%;
    border: 6px solid #000000;
    border-color: #000000 transparent #000000 transparent;
    animation: ${RingAnimation} 1.2s linear infinite;
  }
`

export const Fade = styled.div`
	animation-duration: 1s;
	animation-name: ${FadeIn};
	animation-fill-mode: both;
`;

export  const ProductList = styled.div`
  display:flex;
  flex-wrap:wrap;
  margin:0 -10px;
`;

export  const ProductItem = styled.div`
  position: relative;
  width: 100%;
  padding: 0 10px;
  @media (min-width:768px) {    
	flex: 0 0 50%;
	max-width: 50%;
  }

  @media (min-width:1200px) {
	flex: 0 0 33.33333%;
	max-width: 33.33333%;
  }
`;



export const GridPanel = styled.div`    
    display: flex;
    flex-wrap: wrap;
	align-items: ${(props) => props.alignItems};
    margin:0 -15px;
    @media (min-width: 992px){ 
        margin:0 -20px;
    }
`
export const GridItemPanel = styled.div`
    position: relative;
    width:100%;
    padding:0 15px;	
    @media (min-width: 992px){ 
        padding:0 20px;
        flex:0 0 50%;
		max-width:50%;
    }
`
export const GridLeftPanel = styled.div`
    position: relative;
    width:100%;
    padding:0 15px;
    @media (min-width: 992px){ 
        padding:0 20px;
        flex-basis: 0;
        flex-grow: 1;
        max-width: 100%;
    }
`
export const GridRightPanel = styled.div`
    position: relative;
    width:100%;
    padding:0 15px;
    @media (min-width: 992px){ 
        padding:0 20px;
        flex: 0 0 33.33333%;
        max-width: 33.33333%;
    }
`


export const CallExpert = styled.div`
	display:flex;
	flex-wrap:wrap;
	align-items:center;
	margin:0 -10px;
	@media(min-width:1200px){
		margin:0 -20px;
	}
	@media(min-width:1600px){
		margin:0 -40px;
	}
`
 
export const LeftCallExpert = styled.div`
	position: relative;
	width:100%;
	padding:0 10px;
	@media(min-width:768px){
		max-width:40%;
		flex:0 0 40%;
	}
	@media(min-width:992px){
		max-width:45%;
		flex:0 0 45%;
	}
	@media(min-width:1200px){
		padding:0 20px;
	}
	@media(min-width:1600px){
		padding:0 40px;
	}
	h2{
		font-size: 28px;
		line-height: 36px;
		@media (min-width: 768px) {
			font-size: 32px;
			line-height: 42px;
		}
		@media (min-width: 992px) {
			font-size: 42px;
			line-height: 52px;
		}
		@media (min-width: 1600px) {
			font-size: 62px;
			line-height: 72px;
		}
	}
`

export const RightCallExpert = styled.div`
	position: relative;
	width:100%;
	padding:0 10px;
	@media(min-width:768px){
		max-width:60%;
		flex:0 0 60%;
	}
	@media(min-width:992px){
		max-width:55%;
		flex:0 0 55%;
	}
	@media(min-width:1200px){
		padding:0 20px;
	}
	@media(min-width:1600px){
		padding:0 40px;
	}
	.markdown p a{
		color:#d7272c;
		&:hover, &:focus {
			color:#fff;
		}
	}
`

export const CardPrimary = styled.div`
	position: relative;
	border-radius: 6px;
	background-color: #381F1F;
	color:#fff;
	
	`
export const CardPrimaryBody  = styled.div`
	padding:20px 15px;
	@media(min-width:768px){
		padding:30px;
	}
	.form-control {
		color: #fff;
		background-color: rgba(255, 255, 255, 0.1);
		border: 1px solid rgba(255, 255, 255, 0.5);    
		box-shadow: 0 3px 12px rgba(0, 0, 0, .1);

		&:focus,
		&:active {
			border-color: #fff;
			&::placeholder {
			color: #fff;
			}
		}
		&::placeholder {
			color: rgba(255, 255, 255, 0.2);
		}
	}
`
export const CarDefault = styled.div`
	position: relative;	
	background-color: #fff;
	border: 1px solid #C9C9C9;
	box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
	border-radius: 15px;
	margin-bottom:30px;
	height:calc(100% - 30px);	
`
export const CarDefaultBody  = styled.div`
	padding:20px 15px;
	@media(min-width:768px){
		padding:30px;
	}
`
export const CardFigure  = styled.div`
	height:180px;
	overflow:hidden;

	.gatsby-image-wrapper{
		width:100%;
		@media(min-width:768px){
			height:100%;
		}
	}
`
export const CardDesc  = styled.div`
	p{
		font-size:16px;
		line-height:26px;
		color:#574C4C;
	}
	span{
		font-size:14px;
		line-height:24px;
		color:#574C4C;
	}
`
 
export const CardTitle  = styled.div`
	color:#000;	
	font-size: 18px;
	line-height: 28px;
	margin-bottom: 10px;
	font-weight:700;
	@media (min-width: 768px) {
		font-size: 20px;
		line-height: 30px;
	}
	@media (min-width: 992px) {
		font-size: 24px;
		line-height: 34px;
	}
	@media (min-width: 1600px) {
		font-size: 28px;
		line-height: 38px;
	}
`
export const CardLink  = styled.div`
`


export  const ListFeatures = styled.div`
	display: flex;
	flex-wrap: wrap;
	align-items: center;
	justify-content: center;
	margin:15px -15px 0 -15px;
	@media (min-width: 992px) {
		margin:25px -25px 0 -25px;
	}

`
export  const FeaturesItem = styled.div`
	padding: 2px 15px;
	color: #000;
	text-align: center;
	font-weight:500;
	
	@media (min-width: 768px) {
		font-size: 18px;
		line-height: 28px;
		+ .feature-item{			
			border-left: 1px solid #000;
		}
	}
	@media (min-width: 992px) {
		padding: 5px 25px;
		font-size: 24px;
		line-height: 34px;
	}
	@media (min-width: 1600px) {
		font-size: 28px;
		line-height: 38px;
	}
`

